export default {
      id: "package-icon-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#package-icon",
      toString: function () {
        return this.url;
      }
    }